import Vue from 'vue'
import Vuex from 'vuex'
import usuario from './modules/usuario';
import pagina from './modules/pagina';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    usuario,
    pagina,
  }
})
